import React from "react";
import { HashRouter as Router, Route, Routes } from "react-router-dom";

function App() {
  return (
    <Router>
      <div style={{ padding: "20px", maxWidth: "800px", margin: "auto", fontFamily: "Arial, sans-serif" }}>
        <h1>Gizlilik Politikası</h1>
        <p>Bu uygulama kullanıcı verilerini toplamaz, işlemez veya paylaşmaz.</p>

        <h2>1. Genel Bilgi</h2>
        <p>Uygulama herhangi bir kişisel veri toplamamaktadır.</p>

        <h2>2. Üçüncü Taraf Hizmetleri</h2>
        <p>Herhangi bir üçüncü taraf hizmetle veri paylaşımı yapılmamaktadır.</p>

        <h2>3. Sorumluluk Reddi</h2>
        <p>Bu uygulama hiçbir kullanıcı verisi toplamadığından dolayı, herhangi bir veri güvenliği ihlalinden sorumlu değildir.</p>
      </div>
    </Router>
  );
}

export default App;
